var _rect, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 139,
    viewBox: "0 0 318 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_458_1831",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 318,
    height: 139
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.951904,
    width: 318,
    height: 137.446,
    rx: 8,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_458_1831)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 318,
    height: 137,
    rx: 8,
    fill: "#D0E9E5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.775 86.35C182.85 86.2 182.85 86.125 182.85 85.975C182.85 85.9 182.85 85.9 182.85 85.825C182.85 85.75 182.85 85.6 182.925 85.525C182.925 85.375 182.925 85.225 182.925 85V56.5C182.925 54.025 180.9 52 178.425 52H139.5C137.025 52 135 54.025 135 56.5V85C135 87.475 137.025 89.5 139.5 89.5H141H177.75H178.5C180.375 89.5 181.95 88.375 182.625 86.725C182.7 86.575 182.775 86.5 182.775 86.35ZM139.5 55H178.5C179.325 55 180 55.675 180 56.5V81.25L171.825 71.725C171.3 71.125 170.4 71.05 169.725 71.5L161.85 77.8L152.025 67.15C151.725 66.85 151.275 66.625 150.9 66.7C150.45 66.7 150.075 66.925 149.775 67.3L138 82.15V56.5C138 55.675 138.675 55 139.5 55Z",
    fill: "#75CAB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 69.25C171.314 69.25 174 66.5637 174 63.25C174 59.9363 171.314 57.25 168 57.25C164.686 57.25 162 59.9363 162 63.25C162 66.5637 164.686 69.25 168 69.25Z",
    fill: "#75CAB2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlaceholder);
export default __webpack_public_path__ + "static/media/card_placeholder.30d1db539e81a56889d51dff414a825d.svg";
export { ForwardRef as ReactComponent };